export const GET_API_ENDPOINTS = Object.freeze({
    dmtListCustomersFino: 'v1/fetchCustomerlist?dmtType=1',
    dmtListCustomersIserveu: 'v1/fetchCustomerlist?dmtType=2',
    dmtListBeneficiaryFino: 'v1/getBeneficiers',
    authConnect: '/api/Dmt/authConnect',
    getCustomerByVendor: 'v1/get-customerByVendor',
    moneyTransferList: 'v1/getMoneyTransferList',
    getOrderReceipt: 'v1/getOrderReciept',
    checkPermission: 'v1/check_permission'
});

export const POST_API_ENDPOINTS = Object.freeze({
    processCustomerEKYC: 'v1/processCustomerEKYC',
    ekycOtpVerify: 'v1/create-customer',
    resentOtp: 'v1/resentOtp',
    createBeneficiary: 'v1/addBeneficiary',
    generateTxnOtp: 'v1/generateTxnOtp',
    getCustomerLimit: 'v1/customer-limit',
    fundTransfer: 'v1/transaction',
    getChargesDMTTransfer: 'v1/getChargesDMTTransfer',
    deleteBeneficiary: 'v1/deleteBeneficiary',
    editCustomer: 'v1/editCustomer',
    twoFactAuth: 'v1/execute/two_factor_auth',
    balanceEnquiry: 'v1/balance_enquiry',
    miniStatement: 'v1/mini_statement',
    cashWithdrawal: 'v1/cash_withdrawal',
    aadharDeposit: 'v1/cash_deposit',
    aadharPay: 'v1/aadhar_pay',
    paymentReceipt: 'v1/payment_reciept',
    aadharExist: 'v1/aadhar_exist'
});
